import styled from "styled-components";
import themeGet from "@styled-system/theme-get";

import SectionContainer from "../SectionContainer";

import { Heading, FAQsLink } from './common';
import FAQAccordion from './FAQAccordion';

const StyledSectionContainer = styled(SectionContainer)`
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    text-align: center;
  }
`;
const StyledSection = styled.section`
  background-color: ${themeGet('colors.stone')};
  padding: 40px 0;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 80px 0;
  }
`;

interface FAQInsuranceAccordionProps {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  data: any
}

const FAQInsuranceAccordion = ({ data }: FAQInsuranceAccordionProps) => (
  <StyledSection id={data.sectionId}>
    <StyledSectionContainer>
      <Heading>{data.primaryHeadingText}</Heading>
      <FAQAccordion combinatorSectionItems={data.allFAQItems} />
      <FAQsLink href={data.mainFaqPageLink.linkUrl}>
        {data.mainFaqPageLink.linkText}
      </FAQsLink>
    </StyledSectionContainer>
  </StyledSection>
);

export default FAQInsuranceAccordion;
